import { Squares2X2Icon } from '@heroicons/react/24/outline';
import { userAppContext } from '@/context/Context';
import type { UserAppContextType } from '@/router/types';
import { useSearchTabNavigation } from '@/hooks/search/useSearchTabNavigation';
import { buildAllResultsSearch, resolveSearchSource } from '@/utils/allResultsSearch';
import { trackEvent } from '@/utils/analytics';

export function BrowseAllResultsButton({ navIconClass = '' }: { navIconClass?: string }) {
  const { openAllResultsSearch } = useSearchTabNavigation();
  const { restrictSources, groups } = userAppContext() as unknown as UserAppContextType;

  const handleClick = () => {
    trackEvent({
      name: 'navigation_click',
      buttonId: 'header_browse_all_results',
      label: 'Browse all results',
      page: 'global',
      section: 'top_navigation',
      feature: 'search',
      eventCategory: 'navigation',
    });
    const source = resolveSearchSource({ restrictSources, groups });
    openAllResultsSearch(() => buildAllResultsSearch(source));
  };

  return (
    <button
      type="button"
      className="search-spotlight-trigger"
      onClick={handleClick}
      aria-label="Open all results table"
      title="Browse all results"
      data-testid="browse-all-results-button"
    >
      <Squares2X2Icon className={`nav-icon h-6 w-6 ${navIconClass}`} />
    </button>
  );
}

export default BrowseAllResultsButton;
